<template>
  <span>{{ formattedPrice }} </span>
</template>

<script lang="ts" setup>
  // Vue
  import { computed, ComputedRef, defineProps } from 'vue'

  // Translations
  import { useI18n } from 'vue-i18n'
  const { n } = useI18n()

  // Props
  interface Props {
    price: number | string
  }

  const props = defineProps<Props>()

  // Computed
  const formattedPrice: ComputedRef<string> = computed(() => {
    let dividedPrice = Number(props.price)

    // Divide only if it's a whole number
    if (Number.isInteger(dividedPrice)) {
      dividedPrice = dividedPrice / 100
    }

    return n(dividedPrice, 'currency') // Format as currency
  })
</script>
